export const OMIT_FIELD = {
  label: 'EXCLUDE FIELD',
  value: 'omit',
};

export const REQUIRED_BRANCH_FIELD_OPTIONS = [
  {
    label: 'date',
    value: 'date',
    type: 'date',
    required: true,
  },
  {
    label: 'campaign_name',
    value: 'campaign_name',
    type: 'string',
    required: true,
  },
  {
    label: 'cost',
    value: 'cost',
    type: 'number',
    required: true,
  },
];

export const OPTIONAL_BRANCH_FIELD_OPTIONS = [
  {
    label: 'campaign_id',
    value: 'campaign_id',
    type: 'number',
  },
  {
    label: 'country_code',
    value: 'country_code',
    type: 'string',
  },
  // {
  //   label: 'os',
  //   value: 'os',
  //   type: 'string',
  // },
  {
    label: 'ad_set_name',
    value: 'adset_name',
    type: 'string',
  },
  {
    label: 'ad_set_id',
    value: 'adset_id',
    type: 'string',
  },
  {
    label: 'ad_name',
    value: 'ad_name',
    type: 'string',
  },
  {
    label: 'ad_id',
    value: 'ad_id',
    type: 'string',
  },
  {
    label: 'creative_name',
    value: 'creative_name',
    type: 'string',
  },
  {
    label: 'creative_id',
    value: 'creative_id',
    type: 'string',
  },
  {
    label: 'keyword',
    value: 'keyword',
    type: 'string',
  },
  {
    label: 'keyword_id',
    value: 'keyword_id',
    type: 'string',
  },
  {
    label: 'secondary_publisher',
    value: 'secondary_publisher',
    type: 'string',
  },
  {
    label: 'channel',
    value: 'channel',
    type: 'string',
  },
  {
    label: 'agency_name',
    value: 'agency_name',
    type: 'string',
  },
  {
    label: 'agency_id',
    value: 'agency_id',
    type: 'string',
  },
];

// This order will help prevent false positives when auto-mapping (ex ad_name matching ad_set_name)
export const BRANCH_FIELD_AUTOMAP_ORDER = [
  'ad_set_name',
  'ad_set_id',
  'secondary_publisher',
  'campaign_name',
  'country_code',
  'creative_name',
  'campaign_id',
  'creative_id',
  'agency_name',
  'keyword_id',
  'agency_id',
  'ad_name',
  'ad_id',
  'keyword',
  'channel',
  'date',
  'cost',
];

export const BRANCH_FIELD_ALTERNATIVE_VALUES: Record<string, string[]> = {
  date: ['day', 'time', 'stamp'],
  campaign_name: ['promotion_name', 'camp_name'],
  cost: ['amount', 'charge', 'price'],
  campaign_id: ['promotion_id', 'camp_id'],
  country_code: ['country_id', 'country'],
  os: ['operating_system', 'op_sys'],
  ad_set_name: ['ad_group_name', 'pub_set_name', 'pub_group_name', 'plug_set_name', 'plug_group_name'],
  ad_set_id: ['ad_group_id', 'pub_set_id', 'pub_group_id', 'plug_set_id', 'plug_group_id'],
  ad_name: ['pub_name', 'plug_name'],
  ad_id: ['pub_id', 'plug_id'],
  creative_name: ['invent_name'],
  creative_id: ['invent_id'],
  keyword: ['key_text', 'kw_name', 'key_name', 'kw_text'],
  keyword_id: ['keyword_key', 'kw_id', 'key_id'],
  secondary_publisher: ['publisher'],
  channel: ['avenue'],
  agency_name: ['advertiser_name', 'service_name', 'firm_name'],
  agency_id: ['advertiser_id', 'service_id', 'firm_id'],
};
